<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive :exclude="excludeList">
        <component
          :is="Component"
          :key="$route.name"
          v-if="$route.meta.keepAlive"
        />
      </keep-alive>
      <component
        :is="Component"
        :key="$route.name"
        v-if="!$route.meta.keepAlive"
      />
    </router-view>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: 'App',
  setup() {
    const router = useRouter();

    // 需要清除的缓存路由
    const excludeList = ref([]);
    // // 清除缓存
    const addExcludeList = [{
        to: "/leaderindex",
        from: "/opportunity_winper_add",
        name: "opportunity_winper_add",
      },
    ];

    // 取消清除缓存
    const clearExcludeList = [{
        to: "/opportunity_winper_add",
        from: "/leaderindex",
        name: "opportunity_winper_add",
      },
    ];

    router.beforeEach((to, from, next) => {
      addExcludeList.forEach((item) => {
        if (to.path === item.to && from.path === item.from) {
          if (excludeList.value.indexOf(item.name) < 0) {
            // 不存在
            excludeList.value.push(item.name);
          }
        }
      });

      clearExcludeList.forEach((item) => {
        if (to.path === item.to && from.path === item.from) {
          if (excludeList.value.indexOf(item.name) >= 0) {
            // 存在
            excludeList.value.splice(excludeList.value.indexOf(item.name), 1);
          }
        }
      });
      next();
    });
    return {
      excludeList
    }
  }
});
</script>